module.exports = __webpack_public_path__ + "root-c2082cbd/69efacf8307527250317248dcb70e0b1.woff2";